import { Injectable } from '@angular/core';
import { Canvas, FabricObject } from 'fabric';
import { ObjectTypeEnum } from '../../_enums/object-type.enum';

@Injectable({
    providedIn: 'root',
})
export class MnemonicCanvasObjectResolver {
    resolveActiveObject(canvas: Canvas, currentObject: any): FabricObject | undefined {
        const activeObject = canvas.getActiveObject();

        if (activeObject) {
            return activeObject;
        }

        if (!currentObject || currentObject === canvas) {
            return undefined;
        }

        if (currentObject.id) {
            const canvasObject = canvas.getObjects().find((obj: any) => obj.id === currentObject.id);
            if (canvasObject) {
                return canvasObject;
            }
        }

        return typeof currentObject.set === 'function' ? currentObject : undefined;
    }

    isImageObject(object: FabricObject | null | undefined): boolean {
        if (!object) {
            return false;
        }

        const typedObject = object as any;
        return (
            typedObject.type === 'image' ||
            typedObject.objectType === ObjectTypeEnum.image ||
            typedObject.objectType === ObjectTypeEnum.defaultImage
        );
    }

    clampWithinCanvasBounds(target: any): void {
        const obj = target;
        if (obj.height > obj.canvas.height || obj.width > obj.canvas.width) {
            return;
        }

        obj.setCoords();

        if (obj.getBoundingRect().top < 0 || obj.getBoundingRect().left < 0) {
            obj.top = Math.max(obj.top, obj.top - obj.getBoundingRect().top);
            obj.left = Math.max(obj.left, obj.left - obj.getBoundingRect().left);
        }

        if (
            obj.getBoundingRect().top + obj.getBoundingRect().height > obj.canvas.height ||
            obj.getBoundingRect().left + obj.getBoundingRect().width > obj.canvas.width
        ) {
            obj.top = Math.min(obj.top, obj.canvas.height - obj.getBoundingRect().height + obj.top - obj.getBoundingRect().top);
            obj.left = Math.min(obj.left, obj.canvas.width - obj.getBoundingRect().width + obj.left - obj.getBoundingRect().left);
        }
    }
}
